import {createSlice} from "@reduxjs/toolkit";
import {fetchWithMessages} from "@shared/utils/api/fetchWithMessages";

export const appConfigSlice = createSlice({
  name: "appConfig",
  initialState: {
    editing: {},
  },
  reducers: {
    setEditing: (state, action) => {
      state.editing = action.payload;
    },
  },
});

const asyncActions = {
  loadEditing: () => async (dispatch, getState) => {
    const data = await fetchWithMessages("appConfig", {method: "GET"});
    await dispatch(appConfigActions.setEditing(data));
  },
  persist: (fieldsToUpdate) => async (dispatch, getState) => {
    const state = getState();
    // If some fields are given as argument, directly take this to update the config
    const payload = fieldsToUpdate || state.appConfig.editing;
    const updatedData = await fetchWithMessages("appConfig", {method: "PATCH", body: payload});
    await dispatch(appConfigActions.setEditing(updatedData));
  },
};

export const appConfigSelectors = {
  selectEditing: (state) => state.appConfig.editing,
};

export const appConfigReducer = appConfigSlice.reducer;

export const appConfigActions = {
  ...appConfigSlice.actions,
  ...asyncActions,
};
